/*
  dzc-rail-nav.js — makes a horizontal rail visibly scrollable.

  The rails scroll natively, which is fine on touch (swipe) but invisible on
  a desktop with a mouse: no scrollbar, no arrows, nothing to grab. This adds
  the two affordances and keeps them honest — an arrow that can't go anywhere
  is dimmed, and the progress bar reports real scroll extent rather than being
  decorative.

  DzcRailNav.init(root) — root contains [data-dzr-row] plus, optionally,
  [data-dzr-prev] / [data-dzr-next] / [data-dzr-thumb].

  Everything degrades: with JS off the rail still scrolls by swipe/trackpad,
  and the controls are hidden by default until this marks the rail live, so
  they never sit there dead.
*/
window.DzcRailNav = window.DzcRailNav || (function () {
  function init(root) {
    if (!root || root.dataset.dzrNavBound === '1') return;
    var row = root.querySelector('[data-dzr-row]');
    if (!row) return;
    root.dataset.dzrNavBound = '1';

    var prev  = root.querySelector('[data-dzr-prev]');
    var next  = root.querySelector('[data-dzr-next]');
    var thumb = root.querySelector('[data-dzr-thumb]');

    /* how far one nudge travels: most of a screenful, so the shopper keeps
       a card or two of context rather than jumping blind */
    function step() { return Math.max(160, row.clientWidth * 0.8); }

    function overflow() { return row.scrollWidth - row.clientWidth; }

    function update() {
      var max = overflow();
      var scrollable = max > 2;

      /* no overflow = no controls. Never show a dead arrow. */
      root.classList.toggle('dzr-has-nav', scrollable);
      if (!scrollable) {
        if (thumb) thumb.style.width = '100%';
        return;
      }

      var x = row.scrollLeft;
      if (prev) prev.classList.toggle('is-off', x <= 1);
      if (next) next.classList.toggle('is-off', x >= max - 1);

      if (thumb) {
        var ratio = row.clientWidth / row.scrollWidth;         /* visible share */
        var pos   = x / max;                                   /* 0 -> 1 */
        thumb.style.width = (ratio * 100).toFixed(3) + '%';
        /* translate across the leftover track, so the thumb lands flush
           at both ends instead of overshooting */
        thumb.style.transform = 'translateX(' + (pos * (100 / ratio - 100)).toFixed(3) + '%)';
      }
    }

    function nudge(dir) {
      row.scrollBy({ left: dir * step(), behavior: prefersReduced() ? 'auto' : 'smooth' });
    }
    function prefersReduced() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });
    row.addEventListener('scroll', update, { passive: true });

    /* card widths are percentages, so the extent changes with the viewport;
       images also land late and can grow the row */
    if (window.ResizeObserver) new ResizeObserver(update).observe(row);
    else addEventListener('resize', update);
    addEventListener('load', update);

    update();
    return update;
  }

  return { init: init };
})();
